document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll('.mobile-faq');
  if (!containers.length) return;

  containers.forEach(container => {
    const elements = Array.from(container.children);
    let newHTML = '';

    for (let i = 0; i < elements.length; i++) {
      if (elements[i].tagName === 'H2') {
        let title = elements[i].outerHTML;
        let content = '';
        let j = i + 1;

        while (elements[j] && elements[j].tagName !== 'H2') {
          content += elements[j].outerHTML;
          j++;
        }

        i = j - 1;

        newHTML += `
          <div class="faq-block">
            ${title}
            <div class="faq-content">${content}</div>
          </div>
        `;
      }
    }

    container.innerHTML = newHTML;
  });

  document.querySelectorAll('.faq-block h2').forEach(title => {
    title.addEventListener('click', () => {
      if (window.innerWidth <= 768) {
        title.parentElement.classList.toggle('active');
      }
    });
  });
});


window.addEventListener("scroll", function () {

  const nav = document.querySelector(".stycy-nav");
  if (!nav) return;

  let scrollLimit = 200;

  if (window.scrollY > scrollLimit) {
    nav.classList.add("sticky-nav");
  } else {
    nav.classList.remove("sticky-nav");
  }

  const sections = document.querySelectorAll("section[id]");
  const navLinks = document.querySelectorAll(".stycy-nav a");

  let currentSection = "";

  sections.forEach(section => {
    const sectionTop = section.offsetTop - 250;
    const sectionHeight = section.offsetHeight;

    if (
      window.scrollY >= sectionTop &&
      window.scrollY < sectionTop + sectionHeight
    ) {
      currentSection = section.getAttribute("id");
    }
  });

  navLinks.forEach(link => {
    link.classList.remove("active");
    if (link.getAttribute("href") === "#" + currentSection) {
      link.classList.add("active");
    }
  });

});


(function () {

  const menus = document.querySelectorAll('.jump-menu');
  let firstClick = true;

  menus.forEach(menu => {
    const links = menu.querySelectorAll('a');

    links.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        const target = document.querySelector(this.getAttribute('href'));
        if (!target) return;

        const isMobile = window.innerWidth < 768;
        let OFFSET = firstClick ? (isMobile ? 250 : 350) : (isMobile ? 120 : 170);

        window.scrollTo({
          top: target.offsetTop - OFFSET,
          behavior: 'smooth'
        });

        links.forEach(l => l.classList.remove('active'));
        this.classList.add('active');

        if (isMobile) {
          const accordionItem = target.querySelector('.acc-item');
          if (accordionItem) {
            document.querySelectorAll('.acc-item').forEach(item => {
              item.classList.remove('active');
            });
            setTimeout(() => {
              accordionItem.classList.add('active');
            }, 400);
          }
        }

        firstClick = false;
      });
    });
  });

})();


document.addEventListener("DOMContentLoaded", function () {
  const menuLinks = document.querySelectorAll(
    '.desktop-navbar .has-dropdown > .desktop-navbar__link'
  );

  menuLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const parent = this.parentElement;

      document.querySelectorAll('.desktop-navbar__item').forEach(function (item) {
        if (item !== parent) {
          item.classList.remove('active');
        }
      });

      parent.classList.toggle('active');
    });
  });
});


history.scrollRestoration = "manual";

const handleDirectScroll = () => {
  if (window.location.hash === "#video") {
    const target = document.querySelector("#video");
    if (!target) return;

    const offset = window.innerWidth <= 768 ? 100 : 190;
    const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: topPosition,
      behavior: "auto"
    });
  }
};

window.addEventListener("DOMContentLoaded", handleDirectScroll);
window.addEventListener("load", handleDirectScroll);

setTimeout(handleDirectScroll, 100);
setTimeout(handleDirectScroll, 400);
